import React, { Component } from 'react'
import EntryButton from './EntryButton'

class Entry extends Component {
  render() {
    return (
      <section id="entry" className="entry">
        <div className="container center-align">
          <EntryButton id={this.props.id} />
        </div>
      </section>
    )
  }
}

export default Entry